// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__uPBZH","label":"LabeledBox_label__g_4a5"};